import { $admin } from "@/utils/https.js";

export function createUserMessage(id, data) {
    return $admin().post(`/api/cms/manage/titan/user/message/to/user`, data, {
        params: {
            id,
        },
    });
}
export function createOrgMessage(id, data) {
    return $admin().post(`/api/cms/manage/titan/user/message/to/organization`, data, {
        params: {
            id,
        },
    });
}
export function getMessages(params) {
    return $admin().get(`/api/cms/manage/titan/user/message`, { params });
}
export function updateMessage(id, data) {
    return $admin().put(`/api/cms/manage/titan/user/message/${id}`, data);
}
export function deleteMessage(id) {
    return $admin().delete(`/api/cms/manage/titan/user/message`, {
        params: {
            id,
        },
    });
}

// 搜索账号列表
export function getUsers(params) {
    return $admin().get(`/api/admin/titan/user`, {
        params,
    });
}

//内部短消息
// 全部已读
export function readAllMessage() {
    return $admin().put(`/api/admin/manage/admin/message/count`);
}
// 获取未读消息
export function getMessageUnRead() {
    return $admin().get(`/api/admin/manage/admin/message/count`);
}
// 获取收件箱列表
export function getInboxMessages(params) {
    return $admin().get(`/api/admin/manage/admin/message/inbox`, { params });
}
// 获取发件箱列表
export function getOutboxMessages(params) {
    return $admin().get(`/api/admin/manage/admin/message/outbox`, { params });
}
// 删除消息
export function deleteAdminMessage(ids) {
    return $admin().delete(`/api/cms/manage/admin/message`, { params: { id: ids } });
}
// 撤回消息
export function revokeMessage(id) {
    return $admin().delete(`/api/admin/manage/admin/message/revoke`, { params: { id } });
}
// 修改消息
export function updateAdminMessage(id, data) {
    return $admin().put(`/api/admin/manage/admin/message/${id}`, data);
}
// 发送消息
export function sendMessage(data, params) {
    return $admin().post(`/api/admin/manage/admin/message`, data, { params });
}
